import React, { useState } from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import "./digital-vault-categories-administration-details.css"
import { InputHLPure, TextAreaHLPure, ButtonHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'

const DigitalVaultCategoriesAdministrationSubcategoryDetailsView = (props) => {
    const { selectedUser, setShowDetails, updateSubcategory, categories, selectedValueFilter, deleteSubcategory } = props
    const { t } = useTranslation()

    const [categoryData, setCategoryData] = useState
        (
            {
                name: selectedUser.name,
                defined: selectedUser.defined,
                notes: selectedUser.notes ?? "",
            }
        )
    const [selectedFilterText] = useState(categories.find(item => item.company.id === selectedValueFilter).company.companyName)

    const isMobile = useMediaQuery("(max-width:560px)")

    return (
        <>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalVaultCategoriesAdministrationDetails-wrapper"
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <span>
                        {t("digitalVaultCategoriesAdministration.subcategories.details.categoryApplies")} <b>{selectedFilterText}</b>
                    </span>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <InputHLPure
                        labelInput={t("digitalVaultCategoriesAdministration.subcategories.details.categoryType")}
                        typeInput={"text"}
                        inputActive
                        valueInput={categoryData.defined}
                        disabled
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className='digitalVaultCategoriesAdministrationDetails-paddingElements'
                >
                    <InputHLPure
                        labelInput={t("digitalVaultCategoriesAdministration.subcategories.details.subcatTitle")}
                        valueInput={categoryData.name}
                        typeInput={"text"}
                        inputActive
                        handleChangeInput={(e) => setCategoryData({ ...categoryData, name: e.target.value })}
                        informationIcon
                        tooltipShow
                        positionTooltip={isMobile ? "top" : "right"}
                        titleTooltip={t("digitalVaultCategoriesAdministration.subcategories.details.subcatTitle")}
                        descriptionTooltip={t("digitalVaultCategoriesAdministration.subcategories.details.subcatDesc")}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <TextAreaHLPure
                        labelTextArea={t("digitalVaultCategoriesAdministration.subcategories.details.notes")}
                        handleChangeTextArea={(e) => setCategoryData({ ...categoryData, notes: e.target.value })}
                        valueTextData={categoryData.notes ?? ""}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-container-btn"
                >
                    <div className="digitalVaultCategoriesAdministrationDetails-btn-cancel">
                        <ButtonHLPure
                            nameBtn={t("button.cancel")}
                            onClickBtn={() => setShowDetails(false)}
                        />
                    </div>

                    <div className="digitalVaultCategoriesAdministrationDetails-btn-cancel">
                        <ButtonHLPure
                            nameBtn={t("button.delete")}
                            onClickBtn={() => deleteSubcategory(selectedUser.companyId, selectedUser.id)}
                        />
                    </div>

                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary
                        onClickBtn={() => updateSubcategory(categoryData.name, categoryData.notes, categoryData.levelUser, selectedUser.companyCategoryId)}
                    />
                </Grid>
            </Grid>

        </>

    );
}

export default DigitalVaultCategoriesAdministrationSubcategoryDetailsView